import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CheckOutCarDetails {
  vrn: string;
  hubName: string;
  soc: number;
  odo: number;
  token: string;
  // Everest owns the allocation (everest_checkin_apis): the supervisor confirms the car the API
  // sent for this pilot and cannot enter a different vehicle number.
  carSelectionLocked: boolean;
}

interface CarAllocationState {
  carDetails: CheckOutCarDetails | null;
}

const initialState: CarAllocationState = {
  carDetails: null,
};

const carAllocationSlice = createSlice({
  name: 'carAllocation',
  initialState,
  reducers: {
    setCarDetails(state, action: PayloadAction<CheckOutCarDetails>) {
      state.carDetails = action.payload;
    },
  },
});

export const { setCarDetails } = carAllocationSlice.actions;

export default carAllocationSlice.reducer;
